<template>
  <div class="workspace-clientes-page" :style="workspaceAccentStyle">
    <div class="modern-header">
      <div class="header-container">
        <div class="breadcrumb-section">
          <nav class="breadcrumb">
            <button type="button" class="breadcrumb-item" @click="$router.push('/dashboard')">
              <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6"/></svg>
              {{ t('common.breadcrumb.dashboard') }}
            </button>
            <span class="breadcrumb-separator">/</span>
            <button type="button" class="breadcrumb-item" @click="$router.push(`/workspace/${workspaceId}/dashboard`)">
              {{ currentWorkspace?.nome || t('workspaceDashboard.defaultName') }}
            </button>
            <span class="breadcrumb-separator">/</span>
            <span class="breadcrumb-current">{{ t('workspaceClientes.breadcrumbCurrent') }}</span>
          </nav>
        </div>

        <div class="title-section">
          <div class="title-content">
            <div class="title-icon">
              <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2"><path stroke-linecap="round" stroke-linejoin="round" d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0z"/></svg>
            </div>
            <div class="title-text">
              <h1 class="main-title">{{ t('workspaceClientes.title') }}</h1>
              <p class="subtitle">{{ t('workspaceClientes.subtitle') }}</p>
            </div>
          </div>
          <div class="workspace-badge type-servicos">
            <span class="badge-text">{{ t('submenu.workspaceType.servicos') }}</span>
          </div>
        </div>

        <div class="actions-section">
          <div class="ws-cli-stat ws-cli-stat--total ws-cli-stat--header" aria-live="polite">
            <span class="ws-cli-stat__icon" aria-hidden="true">
              <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2">
                <path stroke-linecap="round" stroke-linejoin="round" d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0z"/>
              </svg>
            </span>
            <div class="ws-cli-stat__body">
              <strong>{{ total }}</strong>
              <span>{{ t('workspaceClientes.stats.total') }}</span>
            </div>
          </div>
          <div class="actions-section__buttons">
            <button type="button" class="action-button secondary" :disabled="loading" @click="openCreate">
              + {{ t('workspaceClientes.newCliente') }}
            </button>
            <button type="button" class="action-button primary" @click="$router.push(`/workspace/${workspaceId}/dashboard`)">
              {{ t('workspaceClientes.back') }}
            </button>
          </div>
        </div>
      </div>
    </div>

    <div class="page-content">
      <section class="ws-cli-controls" aria-label="Filtros">
        <div class="ws-cli-panel ws-cli-panel--filters">
          <div class="ws-cli-panel__head">
            <div class="ws-cli-panel__title-wrap">
              <span class="ws-cli-panel__icon" aria-hidden="true">
                <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M3 4a1 1 0 011-1h16a1 1 0 011 1v2.586a1 1 0 01-.293.707l-6.414 6.414a1 1 0 00-.293.707V17l-4 4v-6.586a1 1 0 00-.293-.707L3.293 7.293A1 1 0 013 6.586V4z"/>
                </svg>
              </span>
              <h2 class="ws-cli-panel__title">{{ t('workspaceClientes.filtersTitle') }}</h2>
            </div>
            <button
              v-if="hasActiveFilters"
              type="button"
              class="ws-cli-panel__clear"
              @click="clearFilters"
            >
              {{ t('workspaceClientes.clearFilters') }}
            </button>
          </div>

          <div class="ws-cli-search-wrap">
            <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2" aria-hidden="true">
              <path stroke-linecap="round" stroke-linejoin="round" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"/>
            </svg>
            <input
              v-model="searchNome"
              type="search"
              class="ws-cli-search-wrap__input"
              :placeholder="t('workspaceClientes.searchPlaceholder')"
              @input="onFilterInput"
            />
          </div>

          <div class="ws-cli-filter-accordions">
            <div
              class="ws-cli-accordion"
              :class="{ 'ws-cli-accordion--open': otherFiltersOpen }"
            >
              <button
                type="button"
                class="ws-cli-accordion__trigger"
                :aria-expanded="otherFiltersOpen"
                @click="otherFiltersOpen = !otherFiltersOpen"
              >
                <span class="ws-cli-accordion__trigger-main">
                  <svg class="ws-cli-accordion__trigger-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2" aria-hidden="true">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M12 6V4m0 2a2 2 0 100 4m0-4a2 2 0 110 4m-6 8a2 2 0 100-4m0 4a2 2 0 110-4m0 4v2m0-6V4m6 6v10m6-2a2 2 0 100-4m0 4a2 2 0 110-4m0 4v2m0-6V4"/>
                  </svg>
                  <span class="ws-cli-accordion__label">{{ t('workspaceClientes.otherFiltersTitle') }}</span>
                </span>
                <span class="ws-cli-accordion__value">{{ otherFiltersSummary }}</span>
                <svg class="ws-cli-accordion__chevron" fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2" aria-hidden="true">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M19 9l-7 7-7-7"/>
                </svg>
              </button>
              <div v-show="otherFiltersOpen" class="ws-cli-accordion__panel ws-cli-other-filters">
                <article class="ws-cli-filter-block">
                  <header class="ws-cli-filter-block__head">
                    <span class="ws-cli-filter-block__icon" aria-hidden="true">
                      <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2">
                        <path stroke-linecap="round" stroke-linejoin="round" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zm-4 7a7 7 0 00-7 7h14a7 7 0 00-7-7z"/>
                      </svg>
                    </span>
                    <div class="ws-cli-filter-block__titles">
                      <h3 class="ws-cli-filter-block__title">{{ t('workspaceClientes.otherFiltersContactTitle') }}</h3>
                      <p class="ws-cli-filter-block__hint">{{ t('workspaceClientes.otherFiltersContactHint') }}</p>
                    </div>
                  </header>
                  <div class="ws-cli-filters ws-cli-filters--nested">
                    <label class="ws-cli-field">
                      <span class="ws-cli-field__label">{{ t('workspaceClientes.filterCpfCnpj') }}</span>
                      <span class="ws-cli-field__control">
                        <svg class="ws-cli-field__icon" fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2" aria-hidden="true">
                          <path stroke-linecap="round" stroke-linejoin="round" d="M10 6H5a2 2 0 00-2 2v10a2 2 0 002 2h14a2 2 0 002-2v-5M14 4h6m0 0v6m0-6L10 14"/>
                        </svg>
                        <input
                          v-model="searchCpfCnpj"
                          type="text"
                          class="ws-cli-field__input"
                          inputmode="numeric"
                          :placeholder="t('workspaceClientes.filterCpfCnpjPlaceholder')"
                          @input="onCpfCnpjInput"
                        />
                      </span>
                    </label>
                    <label class="ws-cli-field">
                      <span class="ws-cli-field__label">{{ t('workspaceClientes.filterWhatsapp') }}</span>
                      <span class="ws-cli-field__control">
                        <svg class="ws-cli-field__icon" fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2" aria-hidden="true">
                          <path stroke-linecap="round" stroke-linejoin="round" d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"/>
                        </svg>
                        <input
                          v-model="searchWhatsapp"
                          type="tel"
                          class="ws-cli-field__input"
                          inputmode="tel"
                          :placeholder="t('workspaceClientes.filterWhatsappPlaceholder')"
                          @input="onWhatsappInput"
                        />
                      </span>
                    </label>
                    <label class="ws-cli-field ws-cli-field--wide">
                      <span class="ws-cli-field__label">{{ t('workspaceClientes.filterEmail') }}</span>
                      <span class="ws-cli-field__control">
                        <svg class="ws-cli-field__icon" fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2" aria-hidden="true">
                          <path stroke-linecap="round" stroke-linejoin="round" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"/>
                        </svg>
                        <input
                          v-model="searchEmail"
                          type="email"
                          class="ws-cli-field__input"
                          :placeholder="t('workspaceClientes.filterEmailPlaceholder')"
                          @input="onFilterInput"
                        />
                      </span>
                    </label>
                  </div>
                </article>

                <article class="ws-cli-filter-block">
                  <header class="ws-cli-filter-block__head">
                    <span class="ws-cli-filter-block__icon ws-cli-filter-block__icon--tag" aria-hidden="true">
                      <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2">
                        <path stroke-linecap="round" stroke-linejoin="round" d="M7 7h.01M7 3h5c.512 0 1.024.195 1.414.586l7 7a2 2 0 010 2.828l-7 7a2 2 0 01-2.828 0l-7-7A1.994 1.994 0 013 12V7a4 4 0 014-4z"/>
                      </svg>
                    </span>
                    <div class="ws-cli-filter-block__titles">
                      <h3 class="ws-cli-filter-block__title">{{ t('workspaceClientes.filterTagLabel') }}</h3>
                      <p class="ws-cli-filter-block__hint">{{ t('workspaceClientes.otherFiltersTagsHint') }}</p>
                    </div>
                  </header>
                  <div class="ws-cli-chip-zone">
                    <p v-if="!tags.length" class="ws-cli-accordion__empty">{{ t('workspaceClientes.noTagsConfigured') }}</p>
                    <template v-else>
                      <template v-if="workspaceTags.length">
                        <div
                          v-for="(category, catIndex) in workspaceTags"
                          :key="category.id"
                          class="ws-cli-tag-group"
                        >
                          <span v-if="(category.tags || []).length" class="ws-cli-tag-group__label">{{ category.nome }}</span>
                          <div class="ws-cli-chip-list">
                            <button
                              v-if="catIndex === 0"
                              type="button"
                              class="ws-cli-chip ws-cli-chip--reset"
                              :class="{ 'ws-cli-chip--active': !filterTag }"
                              @click="selectFilterTag('')"
                            >
                              {{ t('workspaceClientes.allTags') }}
                            </button>
                            <WorkspaceTagChip
                              v-for="tag in category.tags || []"
                              :key="tag.id"
                              :tag="tag"
                              :selected="isTagFilterActive(tag.id)"
                              interactive
                              @click="selectFilterTag(tag.id)"
                            />
                          </div>
                        </div>
                      </template>
                      <div v-else class="ws-cli-chip-list">
                        <button
                          type="button"
                          class="ws-cli-chip ws-cli-chip--reset"
                          :class="{ 'ws-cli-chip--active': !filterTag }"
                          @click="selectFilterTag('')"
                        >
                          {{ t('workspaceClientes.allTags') }}
                        </button>
                        <WorkspaceTagChip
                          v-for="tag in tags"
                          :key="tag.id"
                          :tag="tag"
                          :selected="isTagFilterActive(tag.id)"
                          interactive
                          @click="selectFilterTag(tag.id)"
                        />
                      </div>
                    </template>
                  </div>
                </article>

                <article class="ws-cli-filter-block">
                  <header class="ws-cli-filter-block__head">
                    <span class="ws-cli-filter-block__icon ws-cli-filter-block__icon--user" aria-hidden="true">
                      <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2">
                        <path stroke-linecap="round" stroke-linejoin="round" d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0z"/>
                      </svg>
                    </span>
                    <div class="ws-cli-filter-block__titles">
                      <h3 class="ws-cli-filter-block__title">{{ t('workspaceClientes.filterUserLabel') }}</h3>
                      <p class="ws-cli-filter-block__hint">{{ t('workspaceClientes.otherFiltersUsersHint') }}</p>
                    </div>
                  </header>
                  <div class="ws-cli-chip-zone">
                    <p v-if="!workspaceUsers.length" class="ws-cli-accordion__empty">{{ t('workspaceClientes.noUsersConfigured') }}</p>
                    <div v-else class="ws-cli-chip-list ws-cli-chip-list--users">
                      <button
                        type="button"
                        class="ws-cli-chip ws-cli-chip--reset"
                        :class="{ 'ws-cli-chip--active': !filterUsuario }"
                        @click="selectFilterUsuario('')"
                      >
                        {{ t('workspaceClientes.allUsers') }}
                      </button>
                      <WorkspaceUserFilterChip
                        v-for="u in workspaceUsers"
                        :key="u.id"
                        :user="u"
                        :active="isUsuarioFilterActive(u.usuarioId || u.id)"
                        @click="selectFilterUsuario(u.usuarioId || u.id)"
                      />
                    </div>
                  </div>
                </article>
              </div>
            </div>
          </div>
        </div>
      </section>

      <div v-if="loading" class="ws-cli-state">
        <div class="ws-cli-spinner" />
        <p>{{ t('workspaceClientes.loading') }}</p>
      </div>

      <div v-else-if="!clientes.length" class="ws-cli-state">
        <p>{{ t('workspaceClientes.empty') }}</p>
        <button type="button" class="action-button primary" @click="openCreate">{{ t('workspaceClientes.newCliente') }}</button>
      </div>

      <template v-else>
        <div class="ws-cli-list">
          <ClienteListRow
            v-for="cliente in clientes"
            :key="cliente.id"
            :cliente="cliente"
            :tags="tags"
            :show-whats-app="whatsAppConnected"
            @open="openCliente"
            @open-historico="openDrawerTab('historico', $event)"
            @open-whatsapp="openWhatsappCliente"
            @open-agendamento="openDrawerTab('agendamento', $event)"
            @open-financeiro="openDrawerTab('financeiro', $event)"
            @open-anexos="openDrawerTab('anexos', $event)"
          />
        </div>

        <footer v-if="totalPages > 1" class="ws-cli-pagination">
          <span class="ws-cli-pagination__info">
            {{ t('workspaceClientes.pagination.showing', { start: paginationStart, end: paginationEnd, total }) }}
          </span>
          <div class="ws-cli-pagination__controls">
            <button type="button" class="ws-cli-pagination__btn" :disabled="page <= 1" @click="goToPage(page - 1)">
              {{ t('workspaceClientes.pagination.prev') }}
            </button>
            <span class="ws-cli-pagination__page">
              {{ t('workspaceClientes.pagination.pageOf', { current: page, total: totalPages }) }}
            </span>
            <button type="button" class="ws-cli-pagination__btn" :disabled="page >= totalPages" @click="goToPage(page + 1)">
              {{ t('workspaceClientes.pagination.next') }}
            </button>
          </div>
        </footer>
      </template>
    </div>

    <ClienteDetailModal
      :is-open="showModal"
      :cliente="selectedCliente"
      :workspace-id="workspaceId"
      :workspace-tags="workspaceTags"
      :workspace-users="workspaceUsers"
      :motivos-agendamento="motivosAgendamento"
      @close="closeModal"
      @updated="onClienteUpdated"
      @archived="onClienteArchived"
    />

    <ClienteSideDrawerHost
      ref="drawerHostRef"
      :drawer="sideDrawer"
      :workspace-id="workspaceId"
      :motivos-agendamento="motivosAgendamento"
      @close="closeSideDrawer"
      @financeiro-updated="loadClientes"
    />
  </div>
</template>

<script setup>
import { ref, computed, onMounted, watch, nextTick } from 'vue'
import Swal from 'sweetalert2'
import { useRoute, useRouter } from 'vue-router'
import { useI18n } from 'vue-i18n'
import api from '@/services/api'
import { useGlobalWorkspaces } from '@/composables/useGlobalWorkspaces'
import { useWorkspaceAccentStyle } from '@/composables/useWorkspaceAccentStyle'
import { useWorkspaceWhatsAppWebSocket } from '@/composables/useWorkspaceWhatsAppWebSocket'
import ClienteDetailModal from '@/components/ClienteDetailModal.vue'
import ClienteListRow from '@/components/cliente/ClienteListRow.vue'
import ClienteSideDrawerHost from '@/components/cliente/ClienteSideDrawerHost.vue'
import WorkspaceTagChip from '@/components/cliente/WorkspaceTagChip.vue'
import WorkspaceUserFilterChip from '@/components/cliente/WorkspaceUserFilterChip.vue'
import { mapWorkspaceUsers } from '@/utils/mapWorkspaceUsers'
import { useClientesListQuery } from '@/composables/useClientesListQuery'
import { maskCpfCnpj, maskPhoneBr } from '@/utils/inputMasks'

const PAGE_SIZE = 20

const { t } = useI18n()
const route = useRoute()
const router = useRouter()
const { filtersToQuery, queryToFilters } = useClientesListQuery()
const { currentWorkspace } = useGlobalWorkspaces()
const { workspaceAccentStyle } = useWorkspaceAccentStyle()

const workspaceId = computed(() => Number(route.params.id))
useWorkspaceWhatsAppWebSocket(workspaceId)

const loading = ref(false)
const clientes = ref([])
const tags = ref([])
const workspaceTags = ref([])
const workspaceUsers = ref([])
const motivosAgendamento = ref([])

const searchNome = ref('')
const searchCpfCnpj = ref('')
const searchWhatsapp = ref('')
const searchEmail = ref('')
const filterTag = ref('')
const filterUsuario = ref('')
const otherFiltersOpen = ref(false)

const page = ref(1)
const total = ref(0)
const totalPages = ref(0)

const showModal = ref(false)
const selectedCliente = ref(null)
const sideDrawer = ref(null)
const drawerHostRef = ref(null)
const whatsAppConnected = ref(false)

let debounceTimer = null

const paginationStart = computed(() => {
  if (total.value === 0) return 0
  return (page.value - 1) * PAGE_SIZE + 1
})

const paginationEnd = computed(() => {
  if (total.value === 0) return 0
  return Math.min(page.value * PAGE_SIZE, total.value)
})

const otherFiltersSummary = computed(() => {
  const parts = []
  if (searchCpfCnpj.value.trim()) parts.push(t('workspaceClientes.filterCpfCnpj'))
  if (searchWhatsapp.value.trim()) parts.push(t('workspaceClientes.filterWhatsapp'))
  if (searchEmail.value.trim()) parts.push(t('workspaceClientes.filterEmail'))
  if (filterTag.value) {
    const tag = tags.value.find(item => String(item.id) === String(filterTag.value))
    if (tag?.nome) parts.push(tag.nome)
  }
  if (filterUsuario.value) {
    const user = workspaceUsers.value.find(
      item => String(item.usuarioId || item.id) === String(filterUsuario.value)
    )
    const name = user?.usuarioNome || user?.nome
    if (name) parts.push(name)
  }
  if (!parts.length) return t('workspaceClientes.otherFiltersAll')
  return parts.join(' · ')
})

const isTagFilterActive = (tagId) => String(filterTag.value) === String(tagId)

const isUsuarioFilterActive = (userId) => String(filterUsuario.value) === String(userId)

const selectFilterTag = (tagId) => {
  if (tagId === '') {
    filterTag.value = ''
  } else {
    const next = String(tagId)
    filterTag.value = filterTag.value === next ? '' : next
  }
  onFilterChangeImmediate()
}

const selectFilterUsuario = (userId) => {
  if (userId === '') {
    filterUsuario.value = ''
  } else {
    const next = String(userId)
    filterUsuario.value = filterUsuario.value === next ? '' : next
  }
  onFilterChangeImmediate()
}

const hasActiveFilters = computed(() =>
  !!(
    searchNome.value.trim() ||
    searchCpfCnpj.value.trim() ||
    searchWhatsapp.value.trim() ||
    searchEmail.value.trim() ||
    filterTag.value ||
    filterUsuario.value
  )
)

const clearFilters = () => {
  searchNome.value = ''
  searchCpfCnpj.value = ''
  searchWhatsapp.value = ''
  searchEmail.value = ''
  filterTag.value = ''
  filterUsuario.value = ''
  onFilterChangeImmediate()
}

const currentListQuery = () =>
  filtersToQuery({
    nome: searchNome.value,
    cpfCnpj: searchCpfCnpj.value,
    email: searchEmail.value,
    whatsapp: searchWhatsapp.value,
    tag: filterTag.value,
    usuario: filterUsuario.value,
    page: page.value
  })

const syncRouteQuery = () => {
  const next = currentListQuery()
  const current = route.query
  const same =
    String(current.nome || '') === String(next.nome || '') &&
    String(current.cpfCnpj || current.cpf || '') === String(next.cpfCnpj || '') &&
    String(current.email || '') === String(next.email || '') &&
    String(current.whatsapp || '') === String(next.whatsapp || '') &&
    String(current.tag || '') === String(next.tag || '') &&
    String(current.usuario || '') === String(next.usuario || '') &&
    String(current.page || '1') === String(next.page || '1')
  if (!same) {
    router.replace({ query: next })
  }
}

const onCpfCnpjInput = (event) => {
  searchCpfCnpj.value = maskCpfCnpj(event.target.value)
  onFilterInput()
}

const onWhatsappInput = (event) => {
  searchWhatsapp.value = maskPhoneBr(event.target.value)
  onFilterInput()
}

const onFilterInput = () => {
  clearTimeout(debounceTimer)
  debounceTimer = setTimeout(() => {
    page.value = 1
    syncRouteQuery()
    loadClientes()
  }, 350)
}

const onFilterChangeImmediate = () => {
  page.value = 1
  syncRouteQuery()
  loadClientes()
}

const loadClientes = async () => {
  loading.value = true
  try {
    const params = {
      page: page.value,
      size: PAGE_SIZE
    }
    if (searchNome.value.trim()) params.nome = searchNome.value.trim()
    if (searchCpfCnpj.value.trim()) params.cpfCnpj = searchCpfCnpj.value.trim()
    if (searchEmail.value.trim()) params.email = searchEmail.value.trim()
    if (searchWhatsapp.value.trim()) params.whatsapp = searchWhatsapp.value.trim()
    if (filterTag.value) params.tag = filterTag.value
    if (filterUsuario.value) params.usuario = filterUsuario.value

    const { data } = await api.get(`/clientes/workspace/${workspaceId.value}/listagem`, { params })
    clientes.value = Array.isArray(data?.items) ? data.items : []
    total.value = Number(data?.total) || 0
    totalPages.value = Number(data?.totalPages) || 0
    page.value = Number(data?.page) || page.value
  } catch (error) {
    console.error('Erro ao carregar clientes:', error)
    clientes.value = []
    total.value = 0
    totalPages.value = 0
  } finally {
    loading.value = false
  }
}

const goToPage = (nextPage) => {
  if (nextPage < 1 || nextPage > totalPages.value) return
  page.value = nextPage
  syncRouteQuery()
  loadClientes()
}

const loadMeta = async () => {
  try {
    const [configRes, usersRes, motivosRes] = await Promise.all([
      api.get(`/workspace-config/${workspaceId.value}/debug`),
      api.get(`/workspace-acesso/workspace/${workspaceId.value}`),
      api.get(`/workspace-config/${workspaceId.value}/motivos-agendamento`)
    ])
    workspaceTags.value = configRes.data?.categorias || []
    const flat = []
    for (const cat of workspaceTags.value) {
      for (const tag of cat.tags || []) flat.push(tag)
    }
    tags.value = flat
    workspaceUsers.value = mapWorkspaceUsers(usersRes.data || [])
    motivosAgendamento.value = motivosRes.data || []
  } catch (error) {
    console.warn('Meta clientes:', error)
  }
}

const openCreate = () => {
  selectedCliente.value = { workspaceId: workspaceId.value, nome: '', cadastroCompleto: false }
  showModal.value = true
}

const applyFiltersFromRoute = () => {
  const f = queryToFilters(route.query)
  searchNome.value = f.nome
  searchCpfCnpj.value = f.cpfCnpj
  searchEmail.value = f.email
  searchWhatsapp.value = f.whatsapp
  filterTag.value = f.tag
  filterUsuario.value = f.usuario
  page.value = f.page
}

const openCliente = (cliente) => {
  router.push({
    name: 'WorkspaceClienteDetail',
    params: { id: workspaceId.value, clienteId: cliente.id },
    query: { from: 'clientes', ...currentListQuery() }
  })
}

const closeSideDrawer = () => {
  sideDrawer.value = null
}

function openDrawerTab (tab, cliente) {
  sideDrawer.value = {
    tab,
    id: cliente.id,
    nome: cliente.nome,
    telefone: cliente.telefoneWhatsapp || ''
  }
}

const refreshWhatsAppStatus = async () => {
  await drawerHostRef.value?.refreshWhatsAppStatus?.()
  const connected = drawerHostRef.value?.whatsAppConnected
  whatsAppConnected.value = !!(connected?.value ?? connected)
}

const openWhatsappCliente = async (cliente) => {
  const telefone = String(cliente.telefoneWhatsapp || '').trim()
  if (!telefone) {
    await Swal.fire({
      icon: 'info',
      title: t('workspaceClientes.actions.whatsapp'),
      text: t('workspaceClienteModal.whatsapp.phoneMissing'),
      confirmButtonText: 'OK'
    })
    return
  }
  await refreshWhatsAppStatus()
  if (!whatsAppConnected.value) return
  openDrawerTab('whatsapp', { ...cliente, telefoneWhatsapp: telefone })
}

const closeModal = () => {
  showModal.value = false
  selectedCliente.value = null
}

const onClienteUpdated = async () => {
  await loadClientes()
}

const onClienteArchived = async () => {
  await loadClientes()
}

watch(
  () => route.query,
  () => {
    if (route.name !== 'WorkspaceClientes') return
    applyFiltersFromRoute()
    loadClientes()
  }
)

onMounted(async () => {
  applyFiltersFromRoute()
  await Promise.all([loadMeta(), loadClientes()])
  await nextTick()
  await refreshWhatsAppStatus()
})
</script>

<style src="@/assets/styles/workspace-clientes.css"></style>
<style scoped>
.modern-header .breadcrumb-section,
.modern-header .title-section,
.modern-header .header-container {
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  align-items: center;
  justify-content: space-between;
}
.modern-header .header-container { flex-direction: column; align-items: stretch; }
.modern-header .title-section { width: 100%; }
.modern-header .title-content { display: flex; gap: 16px; align-items: center; flex: 1; min-width: 0; }
.modern-header .main-title { font-size: 1.75rem; font-weight: 700; margin: 0; }
.modern-header .subtitle { margin: 4px 0 0; color: var(--text-secondary); font-size: 14px; }
.action-button { display: inline-flex; align-items: center; gap: 8px; padding: 10px 16px; border-radius: 4px; font-size: 14px; font-weight: 600; cursor: pointer; border: 1px solid var(--border-primary); }
.action-button.primary { background: var(--ws-cli-accent, var(--accent-primary, #5865f2)); color: #fff; border-color: transparent; }
.action-button.secondary { background: var(--bg-secondary); color: var(--text-primary); }
.breadcrumb { display: flex; align-items: center; gap: 8px; flex-wrap: wrap; font-size: 13px; }
.breadcrumb-item { display: inline-flex; align-items: center; gap: 6px; color: var(--text-secondary); background: none; border: none; cursor: pointer; }
.breadcrumb-current { color: var(--text-primary); font-weight: 600; }
.breadcrumb-separator { color: var(--text-muted); }
.workspace-badge { padding: 6px 12px; border-radius: 4px; border: 1px solid var(--border-primary); font-size: 12px; font-weight: 700; }
</style>
